export const MAX_ACTIVITY_HOURS=2160;
export const activityPresets=[1,3,24,168,720,2160];
export const activityRangeLabel=(hours:number)=>hours===2160?'Last 3 months (90 days)':hours===720?'Last 30 days':hours===168?'Last 7 days':`Last ${hours} ${hours===1?'hour':'hours'}`;
